import { createReducer, createNamespacer } from '../commons/js/utils/reducer';
import { combineReducers } from "redux";
import { fromPairs as _fromPairs } from 'lodash';

const initialState = {
    list: {
        isPackageLoading: false,
        packageID: { value: "" },
        projectName: { value: "" },
        packagePdfView: false,
        packageInfoUrl: { value: "" },
        packageOptions: [],
        replacePopup: false,
        evolveDrawing: {
            name: "",
            value: "",
            error: "",
            showError: "",
        },
        drawingLoading: false,
        requiredDate:{
            fab: "",
            field: "",
        }
    },
}

const namespacers = {
    listPackages: createNamespacer("LIST_PACKAGES"),
}

const listReducer = createReducer(initialState.list, {
    [namespacers.listPackages("SET_REPLACE_EVOLVE_DRAWING")]: (state, action) => {
        return {
            ...state,
            evolveDrawing: {
                ...state.evolveDrawing,
                value: action.payload.value,
                name: action.payload.value.name,
            },
        }
    },
    [namespacers.listPackages("CLEAR_REPLACE_FORM")]: (state, action) => {
        return {
            ...state,
            evolveDrawing: {
                ...initialState.list.evolveDrawing,
            }
        }
    },
    [namespacers.listPackages("SET_REPLACE_EVOLVE")]: (state, action) => {
        return {
            ...state,
            replacePopup: action.payload.value,
        }
    },
    [namespacers.listPackages("SET_PACKAGE_LOADING")]: (state, action) => {
        return {
            ...state,
            isPackageLoading: action.payload.value,
        }
    },
    [namespacers.listPackages("SET_PDF_VIEW")]: (state, action) => {
        return {
            ...state,
            packagePdfView: action.payload.value,
        }
    },
    [namespacers.listPackages("CLEAR")]: (state, action) => {
        return {
            ...initialState.list,
        }
    },
    [namespacers.listPackages("SET_PACKAGE_OPTIONS")]: (state, action) => {
        return {
            ...state,
            packageOptions: [
                ...state.packageOptions,
                ...action.payload.value
            ],
        }
    },
    [namespacers.listPackages("SET_FIELD_ERRORS")]: (state, action) => {
        let errors = action.payload.value;

        const loadedFields = _fromPairs(Object.entries(errors).map((error) => {
            const [key, value] = error;
            return [key, {
                ...state[key],
                error: value
            }]
        }))

        return {
            ...state,
            ...loadedFields,
        }
    },
    [namespacers.listPackages("SET_DRAWING_LOADING")]: (state, action) => {
        return {
            ...state,
            drawingLoading: action.payload.value,
        }
    },
    [namespacers.listPackages("LOAD_DATA")]: (state, action) => {
        const responseMapping = action.payload.type.includes('fabrication') ?
            {
                batteryName: 'battery_name',
                status: 'status',
                stage: 'abstract_state',
                isRejected: 'rejected',
                itemShipped: 'spools_shipped',
                shippingDate: 'required_date',
                packageInfoUrl: 'zip_or_pdf_drawing_url',
                approved: 'approved',
                rejected: 'rejected',
                fabricationId: 'id'
            }
            : {
                status: 'status',
                stage: 'abstract_state',
                shippingDate: 'required_date',
                isRejected: 'rejected',
                packageInfoUrl: 'zip_or_pdf_drawing_url',
                approved: 'approved',
                rejected: 'rejected',
                fieldId: 'id'
            }

        const loadedFields = _fromPairs(
            Object.entries(responseMapping).map((entry) => {
                const [key, responseKey] = entry;
                return [key, {
                    ...state[key],
                    value: action.payload.type.includes('fabrication') ? action.payload.value.fabrication[responseKey] : action.payload.value.field[responseKey]
                }]
            })
        )
        let updatedRequiredDate = {};
        if(action.payload.value.fabrication.required_date && action.payload.value.field.required_date){
            updatedRequiredDate = {
                fab: action.payload.value.fabrication.required_date,
                field: action.payload.value.field.required_date,
            }
        }
        return {
            ...state,
            ...loadedFields,
            packageID: { value: action.payload.value.package_ID, label: action.payload.value.package_ID },
            projectName: { value: action.payload.value.project_name },
            requiredDate: {...updatedRequiredDate}
        }
    },
});

const reducer = combineReducers({
    list: listReducer,
})

export default reducer;